export const ALLERGY_FIELD_LIMITS = {
  enda_id: 2,
  alg_name: 250,
  alg_onset: 50,
  alg_symp: 1000,
  alg_drug_struc: 300,
  alg_stage: 1
}

const TEXT_KEYS = Object.keys(ALLERGY_FIELD_LIMITS)

function positiveInt (value) {
  if (value == null || value === '') return null
  const n = Number(value)
  if (!Number.isInteger(n) || n <= 0) return null
  return n
}

function boundedText (value, max) {
  const text = String(value).trim()
  if (!max || text.length <= max) return text
  return text.slice(0, max)
}

/**
 * Body for PATCH /api/allergies.
 * Requires alg_id and rid, plus at least one updatable field.
 * Blank values are omitted so the server keeps the current value.
 * user_id is never sent.
 */
export function buildAdminAllergyPatch (form) {
  const src = form || {}
  const algId = positiveInt(src.alg_id)
  const rid = positiveInt(src.rid)
  if (algId == null || rid == null) return null

  const payload = { alg_id: algId, rid }
  TEXT_KEYS.forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(src, key)) return
    const value = src[key]
    if (value == null || String(value).trim() === '') return
    payload[key] = boundedText(value, ALLERGY_FIELD_LIMITS[key])
  })

  if (Object.prototype.hasOwnProperty.call(src, 'naranjo') && src.naranjo !== '' && src.naranjo != null) {
    const n = Number(src.naranjo)
    if (!Number.isInteger(n) || n < 0 || n > 255) return null
    payload.naranjo = n
  }

  if (src.alg_approve === 1 || src.alg_approve === '1' || src.alg_approve === true) {
    payload.alg_approve = 1
  }

  if (Object.keys(payload).length < 3) return null
  return payload
}

export const ALLERGY_LIST_MATCH_METHODS = {
  NORMALIZED_EXACT: 'ชื่อตรง',
  ALIAS_EXACT: 'ชื่อในวงเล็บตรง'
}

export const ALLERGY_SUGGESTION_METHODS = {
  EXACT_NAME: 'ชื่อตรง',
  APPROVED_ALIAS: 'ชื่อที่อนุมัติแล้ว',
  TRIGRAM_REVIEW: 'ชื่อคล้าย'
}

export function allergySuggestionTop (top) {
  if (top == null || top === '') return 5
  const n = Number(top)
  if (!Number.isFinite(n)) return 5
  const whole = Math.floor(n)
  if (whole < 1) return 1
  if (whole > 20) return 20
  return whole
}

export function allergySuggestionRows (data) {
  if (Array.isArray(data)) return data
  if (data && Array.isArray(data.items)) return data.items
  return []
}

export function allergyPrefillApplied (item) {
  if (!item) return false
  if (item.prefill_applied === true || item.prefill_applied === 1 || String(item.prefill_applied) === '1') return true
  const method = item.match_method
  const score = Number(item.match_score)
  const exact = (method === 'NORMALIZED_EXACT' && score === 100) || (method === 'ALIAS_EXACT' && score === 95)
  if (!exact || Number(item.distinct_code_count) > 1) return false
  return String(item.alg_drug_struc || '').trim() !== ''
}

export function allergyMatchLabel (item) {
  if (!allergyPrefillApplied(item)) return ''
  const method = item && item.match_method
  if (ALLERGY_LIST_MATCH_METHODS[method]) return ALLERGY_LIST_MATCH_METHODS[method]
  const score = Number(item && item.match_score)
  if (score === 100) return ALLERGY_LIST_MATCH_METHODS.NORMALIZED_EXACT
  if (score === 95) return ALLERGY_LIST_MATCH_METHODS.ALIAS_EXACT
  return ''
}

export function allergySuggestionLabel (row) {
  const method = row && row.match_method
  return ALLERGY_SUGGESTION_METHODS[method] || ''
}

export function allergySuggestionNeedsReview (row) {
  return row && row.match_method === 'TRIGRAM_REVIEW'
}

/**
 * Code to send on PATCH. The list may fill alg_drug_struc without writing it.
 * A selected suggestion is not stored until this value is sent.
 */
export function allergyDrugStructureToSave (formValue, item) {
  const next = String(formValue == null ? '' : formValue).trim()
  if (!next) return ''
  const row = item || {}
  const clipped = next.slice(0, ALLERGY_FIELD_LIMITS.alg_drug_struc)
  if (allergyPrefillApplied(row)) return clipped
  if (row.stored_alg_drug_struc == null || String(row.stored_alg_drug_struc).trim() === '') return clipped
  if (clipped !== String(row.stored_alg_drug_struc).trim()) return clipped
  return ''
}

export function allergyMaxLengthRule (max) {
  return (value) => {
    if (value == null || value === '') return true
    return String(value).length <= max || `ไม่เกิน ${max} ตัวอักษร`
  }
}

export function messageFromAdminAllergyError (err) {
  const data = err && err.response && err.response.data
  if (data && typeof data.error === 'string' && data.error) return data.error
  if (data && typeof data.message === 'string' && data.message) return data.message
  const status = err && err.response && err.response.status
  if (status === 401 || status === 403) return 'ไม่มีสิทธิ์อนุมัติรายการแพ้'
  if (status === 404) return 'ไม่พบรายการแพ้นี้'
  if (status === 400) return 'ข้อมูลไม่ครบหรือไม่ถูกต้อง'
  return (err && err.message) || 'บันทึกไม่สำเร็จ'
}
